import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/menu`;

export const ACTION_TYPES = {
  FETCH_MENU_LIST: 'menu/FETCH_MENU_LIST',
  FETCH_MENU: 'menu/FETCH_MENU',
  CREATE_MENU: 'menu/CREATE_MENU',
  UPDATE_MENU: 'menu/UPDATE_MENU',
  DELETE_MENU: 'menu/DELETE_MENU',
  RESET: 'menu/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const menuReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_MENU_LIST):
    case REQUEST(ACTION_TYPES.FETCH_MENU):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_MENU):
    case REQUEST(ACTION_TYPES.UPDATE_MENU):
    case REQUEST(ACTION_TYPES.DELETE_MENU):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_MENU_LIST):
    case FAILURE(ACTION_TYPES.FETCH_MENU):
    case FAILURE(ACTION_TYPES.CREATE_MENU):
    case FAILURE(ACTION_TYPES.UPDATE_MENU):
    case FAILURE(ACTION_TYPES.DELETE_MENU):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MENU_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_MENU):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_MENU):
    case SUCCESS(ACTION_TYPES.UPDATE_MENU):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_MENU):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default menuReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_MENU_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_MENU,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_MENU,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_MENU,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_MENU,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { errorMessage: `Gagal hapus!`, successMessage: `Berhasil Hapus!` },
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
